export default __webpack_public_path__ + "static/media/drinks, coffee & tea_cat_disabled.fc9f382b.png";